import { UsageTrackerProvider } from 'marketplace-ui-tracking';
import { SearchResultViewTracker } from 'marketplace-ui-tracking/events/marketplace';
import { combineTrackingProps } from '../../utils/trackingProps';
import { jsx as _jsx } from "react/jsx-runtime";
export function MarketplaceCardBase({
  children,
  componentType,
  listing,
  tracker,
  trackingProps
}) {
  // Clone with standalone:true for queue isolation, and preserveTrackerProperties:true
  // so that baseline properties set on the parent tracker (embed, inAppOrPublic, hostApp)
  // are inherited by the cloned tracker and included on all card events.
  const isolatedTracker = tracker.clone({
    standalone: true,
    preserveTrackerProperties: true
  });
  return /*#__PURE__*/_jsx(UsageTrackerProvider, {
    tracker: isolatedTracker,
    children: /*#__PURE__*/_jsx(SearchResultViewTracker, Object.assign({}, combineTrackingProps({
      componentType,
      listing,
      trackingProps
    }), {
      children: children
    }))
  });
}